export default "__VITE_ASSET__CfSvLJSN__"